import Vue from 'vue'
import SimpleDialog from '@/components/dialog/simple-dialog/index.vue'

export default Vue.extend({
  name: 'Withdrawal',
  components: {
    SimpleDialog
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('withdraw').then(() => {
        this.$router.push({ path: `/withdrawal/complete` })
      })
    },
    handleCompleted() {
      this.show = true
    },
    returnToProfile(): void {
      this.$router.push({ path: `/profile` })
    }
  }
})
